


















import Vue from "vue";
import { action, mutations, store } from "../../services/store";
import { withdraw } from "../../services";
import { ACTIVITY_UID } from "@/utils/config";
import { openScheme, getScheme } from "@/utils/openUrl";
import { redbagPageUrl } from "@/utils/config";
import { IWithdrawParams } from "@/types";

export default Vue.extend({
  data() {
    return {
      desc: "你可以前往「个人页-弹幕宝箱」继续参加活动哦～等你回来！",
      isShare: true
    };
  },
  computed: {
    withdrawValue(): number {
      return store.taskInfo?.pop_up?.value;
    },
    awardId(): string {
      return store.taskInfo?.pop_up?.award_id;
    },
    bgClass(): string {
      switch (this.withdrawValue) {
        case 50: return "bg-50";
        case 100: return "bg-100";
        default: return "";
      }
    }
  },
  methods: {
    close() {
      this.$dialog.close("withdraw");
    },
    withdraw() {
      this.close();
      // 去提现
      const withdrawParams: IWithdrawParams = {
        activity_uid: ACTIVITY_UID,
        id: +this.awardId
      };
      if (this.isShare) {
        withdrawParams.from = 1;
      }
      withdraw(withdrawParams);
      mutations.setGlobalLoading(true);
      setTimeout(() => {
        const scheme = getScheme("browser", redbagPageUrl);
        openScheme(scheme);
        action.updatePrizes();
        mutations.setGlobalLoading(false);
      }, 2000);
    },
    toggleIsShare() {
      this.isShare = !this.isShare;
    }
  }
});
